// Epic 7 re-skin (ADO-903): grid/list view-mode state. The listing opens in the grid
// view at every width (PO decision, 2026-10-08: the prototype's list default below 768px
// is retired), and the user's toggle holds for as long as the listing stays mounted.
//
// Extracted from CategoryListing so the committed-search results (ProductSearch)
// share the exact same default + toggle behaviour (Epic 7 pixel parity — the two
// listing surfaces must not diverge).

import { useState } from 'react';

export type ViewMode = 'grid' | 'list';

export interface ViewModeState {
  readonly viewMode: ViewMode;
  /** Manual toggle between the grid and list views. */
  readonly selectView: (mode: ViewMode) => void;
}

export function useViewMode(): ViewModeState {
  const [viewMode, setViewMode] = useState<ViewMode>('grid');
  return { viewMode, selectView: setViewMode };
}
